export default __webpack_public_path__ + "static/media/Amulet of Souls.0dec10c6.jpg";